<template>
  <div>
    <SurveyComponent />
  </div>
</template>

<script>

import SurveyComponent from '@/components/Survey.vue';

/* eslint-disable no-console */
export default {
  name: 'Survey',
  components: {
    SurveyComponent,
  },
};
</script>
